export default function useSiteVariables() { return window.siteVariables; }
